export const OrganizationDbInconsistencyLogsResultMockData = [
  {
    scopeName: 'MockScope',
    scopeType: 'Drillhole',
    parentName: 'MockParent',
    parentType: 'Project',
    problem: 'MockProblem',
    fixed: false,
  },
  {
    scopeName: 'MockScope',
    scopeType: 'Drillhole',
    parentName: 'MockParent',
    parentType: 'Project',
    problem: 'MockProblem',
    fixed: true,
  },
] as any[];
